module.exports = __webpack_public_path__ + "../front/img/768_bøjlestang+2hylder.0582f80b.svg";